import styled from '@emotion/styled/macro';
import { Box, Select } from '@chakra-ui/react';
import theme from './../theme/theme';

export const Wrapper = styled(Box)`
  display: flex;
  align-items: start;
  flex-direction: column;
  min-height: ${(props) => props.minHeight || '64px'};
  max-width: ${(props) => props.maxWidth || '100%'};
  width: ${(props) => (props.width ? props.width : '100%')};
  margin-top: ${(props) => (props.marginTop ? props.marginTop : '0px')};
  margin-right: ${(props) => (props.marginRight ? props.marginRight : '0px')};
  margin-left: ${(props) => (props.marginLeft ? props.marginLeft : '0px')};
  margin-bottom: ${(props) =>
    props.marginBottom ? props.marginBottom : '4px'};

  &.states {
    width: ${(props) => (props.width ? props.width : '100px')};
  }
`;

export const Input = styled.input`
  text-align: ${(props) => (props.textAlign ? props.textAlign : 'inherit')};
  font-size: ${(props) => (props.fontSize ? props.fontSize : '1em')};
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : 'normal')};
  border: 1px solid;
  width: 100%;
  height: 52px;
  border-radius: 4px;
  padding: 14px 16px 14px 16px;
  margin-top: 4px;
  margin-bottom: 4px;
  border-color: ${(props) =>
    props.borderColor
      ? `${theme.colors.semantics.error}`
      : `${theme.colors.gray['200']}`};
  &:focus {
    // box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.15);
    border-width: 2px;
    border-color: ${theme.colors.blue['700']};
  }
  &:disabled {
    border-color: ${theme.colors.gray['300']};
    background-color: ${theme.colors.gray['0']};
    color: ${theme.colors.gray['300']};
    cursor: not-allowed;
  }
`;

export const Label = styled.label`
  font-size: 12px;
  font-weight: 600;
  text-transform: capitalize;
  line-height: 12px;
  padding: 0px 0px 0px 16px;
  color: ${(props) =>
    props.color
      ? `${theme.colors.semantics.error}`
      : `${theme.colors.semantics.default}`};
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const StyledSelect = styled(Select)`
  height: 52px;
  margin-top: 4px;
  margin-bottom: 4px;
  border: ${(props) => (props.border ? `${props.border}` : '1px solid')};
  &:disabled {
    opacity: 1;
    border-color: ${theme.colors.gray['300']};
    background-color: ${theme.colors.gray['0']};
    color: ${theme.colors.gray['300']};
  }
`;
